import { ResultsView } from '@kijiji/generated/graphql-types'
import { GridIcon, ListingStackIcon, MapPinLocationIcon } from '@kijiji/icons/src/icons'
import { theme } from '@kijiji/theme'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import { HideAtOrLarger, ShowAtOrLarger } from '@/components/shared/breakpoint'
import { TRANSLATION_KEYS } from '@/constants/localization'
import {
  SrpViewTextLinkButton,
  ViewButtonStyles,
  ViewButtonText,
  ViewFlexContainer,
} from '@/features/map/components/srp-view-button/styled'

export type ViewButtonProps = {
  onClick: (type: ResultsView) => void
  type: ResultsView
}

export const SRPViewButton = ({ onClick, type }: ViewButtonProps) => {
  const { t } = useTranslation(TRANSLATION_KEYS.SRP)

  const Icon = useMemo(() => {
    switch (type) {
      case ResultsView.Map:
        return <MapPinLocationIcon size="xsm" aria-hidden="true" />
      case ResultsView.List:
        return <ListingStackIcon size="xsm" aria-hidden="true" />
      case ResultsView.Grid:
        return <GridIcon size="xsm" aria-hidden="true" />
      default:
        return null
    }
  }, [type])

  const handleClick = () => {
    onClick(type)
  }

  const ctaLabel = t(`srp:view_button.${type.toLocaleLowerCase()}`)

  return (
    <>
      <ShowAtOrLarger breakpoint="medium">
        <ViewButtonStyles
          shape="pill"
          size="compact"
          type="button"
          onClick={handleClick}
          variant="subtle"
          data-testid="toggle-button"
        >
          <ViewFlexContainer
            justifyContent="space-around"
            alignItems="center"
            gap={theme.spacing.mini}
            flexGrow={1}
          >
            {Icon}
            <ViewButtonText>{ctaLabel}</ViewButtonText>
          </ViewFlexContainer>
        </ViewButtonStyles>
      </ShowAtOrLarger>

      <HideAtOrLarger breakpoint="medium">
        <SrpViewTextLinkButton onClick={handleClick} variant="secondary" size="small">
          {Icon}
          {ctaLabel}
        </SrpViewTextLinkButton>
      </HideAtOrLarger>
    </>
  )
}
